import React from 'react';
import { IconProps } from './types';

export const RightChevron = ({ ...svgProps }: IconProps) => (
  <svg
    {...svgProps}
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 1L11 8L4 15"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
